export const and = (...filters) => (value, index, array) => filters.reduce((prev, filter) => prev && filter(value, index, array), true);
export const or = (...filters) => (value, index, array) => filters.reduce((prev, filter) => prev || filter(value, index, array), false);
export const not = (filterFn) => (value, i, array) => !filterFn(value, i, array);
